export default "__VITE_ASSET__f7217233__"